export enum Modal {
  LOGOUT_ALERT = 'LOGOUT_ALERT',
  RETRY_LOGOUT_ALERT = 'RETRY_LOGOUT_ALERT',
  UNKNOW_ALERT = 'UNKNOW_ALERT',
  ARTICLE_ALERT = 'ARTICLE_ALERT',
  ARTICLE_PUBLISH_ALERT = 'ARTICLE_PUBLISH_ALERT',
}
